export const SET_HRMS75E_INDEX_DISP = 'SET_HRMS75E_INDEX_DISP'
export const GET_HRMS75E_INDEX_DISP = 'GET_HRMS75E_INDEX_DISP'
export const SET_HRMS75E_DETAIL_DISP = 'SET_HRMS75E_DETAIL_DISP'
export const GET_HRMS75E_DETAIL_DISP = 'GET_HRMS75E_DETAIL_DISP'
export const TOGGLE_HRMS75E_PAGE = 'TOGGLE_HRMS75E_PAGE'
export const SET_HRMS75E_COLUMNS = 'SET_HRMS75E_COLUMNS'
export const GET_HRMS75E_COLUMNS = 'GET_HRMS75E_COLUMNS'
export const SET_HRMS75E_LABELS = 'SET_HRMS75E_LABELS'
export const GET_HRMS75E_LABELS = 'GET_HRMS75E_LABELS'
export const GET_HRMS75E_MAX_ROWSPAN = 'GET_HRMS75E_MAX_ROWSPAN'
export const RECEIVED_HRMS75E_COLUMNS_LABELS = 'RECEIVED_HRMS75E_COLUMNS_LABELS'
export const SET_HRMS75E_INDEX = 'SET_HRMS75E_INDEX'
export const GET_HRMS75E_INDEX = 'GET_HRMS75E_INDEX'
export const SET_HRMS75E_INDEX_SELECTED = 'SET_HRMS75E_INDEX_SELECTED'
export const GET_HRMS75E_INDEX_SELECTED = 'GET_HRMS75E_INDEX_SELECTED'
export const SET_HRMS75E_DROPDOWNS = 'SET_HRMS75E_DROPDOWNS'
export const GET_HRMS75E_DROPDOWNS = 'GET_HRMS75E_DROPDOWNS'
export const POST_HRMS75E_TAB2_SAVE = 'POST_HRMS75E_TAB2_SAVE'
export const POST_HRMS75E_TAB4_SAVE = 'POST_HRMS75E_TAB4_SAVE'
export const POST_HRMS75E_DETAIL_COURS_SAVE = 'POST_HRMS75E_DETAIL_COURS_SAVE'
export const POST_HRMS75E_INDEX_CANCEL = 'POST_HRMS75E_INDEX_CANCEL'
export const RECEIVED_HRMS75E_INDEX = 'RECEIVED_HRMS75E_INDEX'
export const SET_HRMS75E_DETAIL = 'SET_HRMS75E_DETAIL'
export const GET_HRMS75E_DETAIL = 'GET_HRMS75E_DETAIL'
export const GET_HRMS75E_SEARCH_PARAMS_INDEX = 'GET_HRMS75E_SEARCH_PARAMS_INDEX'
export const SET_HRMS75E_COURS_POPUP = 'SET_HRMS75E_COURS_POPUP'
export const GET_HRMS75E_COURS_POPUP = 'GET_HRMS75E_COURS_POPUP'
export const GET_HRMS75E_DETAIL_TAB2_POPUP = 'GET_HRMS75E_DETAIL_TAB2_POPUP'
export const SET_HRMS75E_DETAIL_TAB2_POPUP = 'SET_HRMS75E_DETAIL_TAB2_POPUP'
export const GET_HRMS75E_DETAIL_TAB4_POPUP = 'GET_HRMS75E_DETAIL_TAB4_POPUP'
export const SET_HRMS75E_DETAIL_TAB4_POPUP = 'SET_HRMS75E_DETAIL_TAB4_POPUP'
export const RECEIVED_HRMS75E_DETAIL_CREATE = 'RECEIVED_HRMS75E_DETAIL_CREATE'
export const RECEIVED_HRMS75E_DETAIL = 'RECEIVED_HRMS75E_DETAIL'
export const GET_HRMS75E_DETAIL_TAB3_SELECTED = 'GET_HRMS75E_DETAIL_TAB3_SELECTED'
export const SET_HRMS75E_DETAIL_TAB3_SELECTED = 'SET_HRMS75E_DETAIL_TAB3_SELECTED'
export const SET_HRMS75E_ADD_CODCOURS = 'SET_HRMS75E_ADD_CODCOURS'
export const RECEIVED_HRMS75E_COURS_POPUP = 'RECEIVED_HRMS75E_COURS_POPUP'
export const RECEIVED_HRMS75E_INDEX_ADD_INLINE = 'RECEIVED_HRMS75E_INDEX_ADD_INLINE'
export const RECEIVED_HRMS75E_DETAIL_TAB2_POPUP = 'RECEIVED_HRMS75E_DETAIL_TAB2_POPUP'
export const RECEIVED_HRMS75E_DETAIL_TAB4_POPUP = 'RECEIVED_HRMS75E_DETAIL_TAB4_POPUP'



// WEBPACK FOOTER //
// ./src/store/modules/hrms75e/mutation-types.js